import AddChat from './add-chat.svg';
import AdjustHeight from './adjust-height.svg';
import AiGenerate from './ai-generate.svg';
import Back from './back.svg';
import Beamy from './beamy.svg';
import Camera from './camera.svg';
import Cloud from './cloud.svg';
import Cursor from './cursor.svg';
import CurveEngrave from './curve-engrave.svg';
import CurvePreview from './curve-preview.svg';
import CurveSelect from './curve-select.svg';
import Delete from './delete.svg';
import DesignMarket from './design-market.svg';
import Draw from './draw.svg';
import Element from './element.svg';
import Image from './image.svg';
import Line from './line.svg';
import Live from './live.svg';
import Oval from './oval.svg';
import PassThrough from './pass-through.svg';
import Photo from './photo.svg';
import Polygon from './polygon.svg';
import QRCode from './qr-code.svg';
import Rect from './rect.svg';
import Send from './send.svg';
import TextBox from './text-box.svg';
import Text from './text.svg';
import Trace from './trace.svg';

export default {
  AddChat,
  AdjustHeight,
  AiGenerate,
  Back,
  Beamy,
  Camera,
  Cloud,
  Cursor,
  CurveEngrave,
  CurvePreview,
  CurveSelect,
  Delete,
  DesignMarket,
  Draw,
  Element,
  Image,
  Line,
  Live,
  Oval,
  PassThrough,
  Photo,
  Polygon,
  QRCode,
  Rect,
  Send,
  Text,
  TextBox,
  Trace,
};
